export const environment = {
    production: true,
    identityUrl: 'https://identity-v2-dev.nside.io',
    withCredentials: true,
    angularAppUrl: 'https://admin-tools-dev.nside.io',
    apiBaseUrl: 'https://v3-api-dev.nside.io',
    fleetApiBaseUrl: 'https://fleet-api-dev.nside.io',
    nSidePlatformUrl: 'https://dev.nside.io',
    mapsApiKey: 'AIzaSyB0xPSuEV1ebWHm-JilyOB7og__PrUN9lo'
};
